<template>
  <a-modal
      :title="modalType === 'create' ? '创建流程' : '编辑流程'"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="visible = false"
      :afterClose="afterClose"
  >
    <a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="调度名称" prop="schedule_name">
        <a-input :size="$globalSize" v-model="form.schedule_name"/>
      </a-form-model-item>
      <a-form-model-item label="调度周期" prop="schedule_exp">
        <a-input :size="$globalSize" v-model="form.schedule_exp"/>
      </a-form-model-item>
      <a-form-model-item label="调度类型" prop="type">
        <a-select :size="$globalSize" v-model="form.type" :disabled="modalType === 'edit'">
          <a-select-option value="all">
            全部
          </a-select-option>
          <a-select-option value="today">
            当天（T+0）
          </a-select-option>
          <a-select-option value="netday">
            次日（T+1）
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="触发时间" prop="trigger_time">
        <a-time-picker v-model="form.trigger_time" :disabled="modalType === 'edit'"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import utils from "@/utils";
import workflow from "@/interface/pages/workflow/workflow";
import moment from "moment";

export default {
  name: "createFlowModal",
  components: {},
  props: {},

  data() {
    return {
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 7
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 17
      },
      visible: false,
      confirmLoading: false,
      modalType:'create',
      form: {},
    };
  },
  mounted() {
    utils.languageChange(this, {labelCol: 9, wrapperCol: 14}, {labelCol: 6, wrapperCol: 16})
  },
  computed: {},
  watch: {},
  methods: {
    showModal(type,data) {
      this.modalType = type
      this.form = {}
      if(type ==='edit'){
        const val = {...data}
        val.trigger_time = moment(val.trigger_time,'HH:mm:ss')
        this.form = {...val}
      }
      this.visible = true
    },
    async submit() {
      const data = {
        ...this.form,
        trigger_time: this.form.trigger_time ? this.form.trigger_time.format('HH:mm:ss') : '',
      }
      const {data: res} = this.modalType === 'create' ? await workflow.addSchedule(this, {data}) : await workflow.updateWorkFlow(this, {data:{...this.form}})
      try {
        if (res.code === '200') {
          this.$message.success(this.modalType === 'create' ?'创建成功':'修改成功')
          this.visible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    },
    afterClose() {
      this.$refs.ruleForm.resetFields()
    }
  },
};
</script>

<style scoped lang="less">
::v-deep .ant-modal-body {
  padding-left: 24px;
}
</style>
